module.exports = __webpack_public_path__ + "static/data-center.7da96c93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/backgrounds/data-center.jpg
// module id = 362
// module chunks = 114276838955818